// extracted by mini-css-extract-plugin
module.exports = {"label":"FirstCreateProductPhase_label__IT-Wr","hide":"FirstCreateProductPhase_hide__khub_","errorMessage":"FirstCreateProductPhase_errorMessage__lzSk5"};